var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Styles from './alert-styles.scss';
import React from 'react';
import { IconClose, IconWarning } from '@/presentation/components/icons';
const AlertBase = (_a) => {
    var { title, description, icon, color } = _a, props = __rest(_a, ["title", "description", "icon", "color"]);
    return (React.createElement("div", { className: Styles.alert, style: { backgroundColor: color && color } },
        React.createElement("div", { className: Styles.icon }, icon || React.createElement(IconWarning, { size: 30 })),
        React.createElement("div", { className: Styles.body },
            React.createElement("div", { className: Styles.title }, title),
            React.createElement("div", { className: Styles.description }, description)),
        React.createElement("div", { className: Styles.closeBtn },
            React.createElement(IconClose, { size: 15 }))));
};
export default AlertBase;
